<template>
    <div class="board-container">
        <div class="board-list-faq">
            <v-expansion-panels v-for="faq in faqs" :key="faq._id" accordion>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div class="board-list-faq__header">
                            <div class="board-list-faq__header-mark">
                                <span>Q</span>
                            </div>
                            <div class="board-list-faq__tit font-pretendard">
                                <span>{{ faq?.subject }}</span>
                            </div>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="board-list-faq__content">
                            <div class="board-list-faq__content-mark"><span>A</span></div>
                            <div class="board-list-faq__txt font-pretendard">
                                <span v-html="faq.content.replace(/\n/g, '<br>')" class="board-list-faq__html"></span>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>
import api from "@/api";

export default {
    props: {
        code: { type: String, default: null },
    },
    data() {
        return {
            faqs: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                await this.search();
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async search() {
            try {
                var { summary, faqs } = await api.v1.center.faqs.gets();
                this.faqs = faqs;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>

<style scoped>
/* Board Style - FAQ */
.board-list-faq {
    border-top: 2px solid var(--v-grey-darken4);
}
.board-list-faq .v-expansion-panel:before {
    box-shadow: none !important;
}
.board-list-faq .theme--light.v-expansion-panels .v-expansion-panel:not(:first-child):after {
    border-color: var(--v-primary-base);
}
.board-list-faq .v-expansion-panel-header {
    padding: 16px 10px;
    border-bottom: 1px solid var(--v-grey-lighten4);
    font-size: var(--txt-font-size-md);
}
.board-list-faq__header {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 10px;
}
.board-list-faq__header-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-size: 1.6rem;
    font-weight: 700;
    color: #fff;
    background-color: var(--v-primary-base);
    margin-right: 12px;
}
.board-list-faq__tit {
    width: 75%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: var(--v-grey-darken4);
    line-height: 1.35;
    /* width: calc(100% - 54px); */
    font-weight: 500;
}
/* .board-list-faq .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: #686868;
} */
.v-expansion-panel-content__wrap {
    padding: 0;
}
.board-list-faq__content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px 10px;
    background: var(--v-grey-lighten5);
}
.board-list-faq__content-mark {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-weight: 700;
    text-align: center;
    color: #fff;
    background-color: var(--v-grey-lighten1);
    margin-right: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin-left: -54px; */
}
.board-list-faq__txt {
    width: 75%;
    color: var(--v-grey-base);
}
/* .board-list-faq__txt,
.board-list-faq__txt > * { 
} */
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .board-list-faq__header {
        padding: 24px 15px;
    }
    .board-list-faq__content {
        padding: 24px 15px;
    }
}
@media (min-width: 1024px) {
    .board-list-faq .v-expansion-panel-header {
        min-height: 64px;
        padding: 0 20px 0 0;
    }
    .board-list-faq__tit {
        width: calc(100% - 64px);
        font-size: 1.8rem;
    }
    /* .board-list-faq__content {
        padding: 24px 24px 24px 64px;
    } */
    /* .board-list-faq__content-mark {
        font-size: 1.8rem;
        width: 64px;
        margin-left: -64px;
        width: 20px;
        font-size: 1.6rem;
        text-align: left;
        margin-left: 0;
    } */
    /* .board-list-faq__txt {
        width: calc(100% - 20px);
    } */
    /* .board-list-faq__txt,
    .board-list-faq__txt > * {
        font-size: 1.6rem;
    } */
}
@media (min-width: 1200px) {
    .board-list-faq__header {
        padding: 32px 20px;
    }
    .board-list-faq__content {
        padding: 32px 20px;
    }
}
</style>
